import { FontAwesome, SimpleLineIcons } from "@expo/vector-icons";
import React, { useContext, useEffect } from "react";
import { TouchableOpacity, View } from "react-native";
import { useDispatch, useSelector } from "react-redux";
import { GOAL_BOX_IDS } from "../../constants/box_id";
import { BOX_HEIGHT, BOX_WIDTH, GOAL_HEIGHT } from "../../constants/size";
import { SoundContext } from "../../contexts/sound";
import { actions } from "../../redux";
import {
  selectBoxBallCountByBoxId,
  selectHasHandByBoxId,
  selectIsBoxDisabledByBoxId,
  selectIsBoxStealByBoxId,
} from "../../redux/selectors";
import { BoxId } from "../../types/box_id";
import { sleep } from "../../utils/sleep";
import { Coin } from "../Coin";

interface Props {
  id: BoxId;
  isGoal?: boolean;
}

export const Box: React.FC<Props> = ({ id, isGoal }) => {
  const isDisabled = useSelector((state) =>
    selectIsBoxDisabledByBoxId(state, id)
  );
  const boxBallCount = useSelector((state) =>
    selectBoxBallCountByBoxId(state, id)
  );
  const hasHand = useSelector((state) => selectHasHandByBoxId(state, id));
  const isSteal = useSelector((state) => selectIsBoxStealByBoxId(state, id));

  const dispatch = useDispatch();

  const { play } = useContext(SoundContext);

  useEffect(() => {
    if (isSteal) {
      play("get");
    }
  }, [isSteal]);

  return (
    <>
      <TouchableOpacity
        disabled={isDisabled}
        onPress={async () => {
          const targetCount = boxBallCount;
          dispatch(actions.handlePressBox({ boxId: id }));
          let nextBoxId = id;
          for (let i = 0; i < targetCount; i++) {
            nextBoxId = ((id + i + 1) % 14) as BoxId;
            await sleep(300);
            await play("coin");
            dispatch(
              actions.releaseBallToBox({
                boxId: nextBoxId as BoxId,
                isLast: i === targetCount - 1,
              })
            );
          }
          if (!GOAL_BOX_IDS.includes(nextBoxId)) {
            dispatch(actions.toggleTurn());
          } else {
            await play("more");
          }
          await sleep(300);
          dispatch(actions.hideHand());
          dispatch(actions.hideSteal());
        }}
      >
        <View
          style={{
            width: BOX_WIDTH,
            height: isGoal ? GOAL_HEIGHT : BOX_HEIGHT,
            padding: 8,
            backgroundColor: isDisabled ? "#fff" : "#ffe",
            borderColor: "#000",
            borderStyle: "solid",
            borderWidth: 3,
            borderRadius: 24,
            flexDirection: "row",
            flexWrap: "wrap",
            alignContent: "center",
            justifyContent: "center",
            gap: 4,
            position: "relative",
          }}
        >
          {hasHand && (
            <FontAwesome
              style={{ position: "absolute" }}
              name="hand-grab-o"
              size={24}
              color="black"
            />
          )}

          {isSteal && (
            <SimpleLineIcons
              style={{ position: "absolute" }}
              name="star"
              size={24}
              color="black"
            />
          )}

          {[...Array(boxBallCount)].map((_, i) => (
            <Coin key={i} />
          ))}
        </View>
      </TouchableOpacity>
    </>
  );
};
